"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeMatch = exports.initialState = void 0;
var lodash_1 = require("lodash");
var immutable_1 = require("immutable");
var constants_1 = require("./constants");
// const debug = cd('app:entities:reducer');
var EntitiesStateRecord = immutable_1.Record({
    matches: immutable_1.Map(),
    markets: immutable_1.Map(),
    tournaments: immutable_1.Map(),
    competitors: immutable_1.Map(),
    odds: immutable_1.Map(),
    sports: immutable_1.Map(),
    bets: immutable_1.Map(),
    betOdds: immutable_1.Map(),
    streams: immutable_1.Map(),
    teams: immutable_1.Map(),
    players: immutable_1.Map(),
    marketTemplates: immutable_1.Map(),
    freebets: immutable_1.Map(),
    freezedOdds: immutable_1.Map(),
    slugs: immutable_1.Map(),
    oddsStatisticMarkets: immutable_1.Map(),
    oddsStatistic: immutable_1.Map(),
    scores: immutable_1.Map(),
    meta: immutable_1.Map(),
    cashOutOrders: immutable_1.Map(),
}, 'EntitiesState');
exports.initialState = new EntitiesStateRecord();
function mergeMatch(prev, next) {
    if (!prev)
        return next;
    return __assign(__assign(__assign({}, prev), next), { markets: lodash_1.union(prev.markets, next.markets) });
}
exports.mergeMatch = mergeMatch;
function reducer(state, action) {
    if (state === void 0) { state = exports.initialState; }
    if (action.type === constants_1.DELETE_ENTITIES) {
        var entitiesToDelete = action.payload;
        var nextState_1 = state;
        lodash_1.forEach(entitiesToDelete, function (ids, key) {
            if (!ids || ids.length === 0)
                return;
            var entityMap = state.get(key);
            nextState_1 = nextState_1.set(key, entityMap.deleteAll(ids));
        });
        return nextState_1;
    }
    if (action.payload && action.payload.entities) {
        var entities = action.payload.entities;
        if (lodash_1.isObject(entities)) {
            var nextState_2 = state;
            lodash_1.forEach(entities, function (values, name) {
                lodash_1.forEach(values, function (entity, id) {
                    var nextEntity;
                    switch (name) {
                        case 'matches': {
                            var prevEntity = nextState_2.get(name).get(id);
                            nextEntity = mergeMatch(prevEntity, entity);
                            break;
                        }
                        default: {
                            var prevEntity = nextState_2.get(name).get(id);
                            if (!prevEntity) {
                                nextEntity = entity;
                            }
                            else {
                                nextEntity = __assign(__assign({}, prevEntity), entity);
                            }
                            break;
                        }
                    }
                    nextState_2 = nextState_2.setIn([name, id], nextEntity);
                });
            });
            return nextState_2;
        }
    }
    return state;
}
exports.default = reducer;
//# sourceMappingURL=reducer.js.map